import Face2OutlinedIcon from '@mui/icons-material/Face2Outlined';

/**
 * Escala de Savin: rarefação feminina de padrão (alopecia androgenética na
 * mulher) em oito estágios de densidade no topo, de I-1 a avançado, mais o
 * padrão frontal. Referência clínica: Savin RC (J Invest Dermatol,
 * 1992;98:604), escala visual de densidade feminina. Mais detalhada que
 * a de Ludwig (ludwig.js), que segue como módulo próprio. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/savin.php.
 */
const savin = {
  key: 'savin',
  name: 'Escala de Savin',
  description: 'Rarefação feminina de padrão, de I-1 a avançado, e frontal',
  details: 'Classifica a rarefação do cabelo feminino no topo da cabeça em oito estágios de densidade, olhando a risca central de cima: de I-1 (densidade normal) a avançado, mais o padrão frontal, quando a perda começa pela linha da frente. Por ter mais estágios que a escala de Ludwig, mostra melhor pequenas mudanças ao longo do tratamento. Um clique marca o estágio do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: Face2OutlinedIcon,
  accent: 'purple',
  options: [
    { value: 'I-1', label: 'I-1', caption: 'Densidade normal', image: 'savin-1.png', help: 'Risca central fina, sem rarefação visível.' },
    { value: 'I-2', label: 'I-2', caption: 'Mínima', image: 'savin-2.png', help: 'Risca um pouco mais larga, com rarefação mínima ao redor.' },
    { value: 'I-3', label: 'I-3', caption: 'Leve', image: 'savin-3.png', help: 'Risca alargada, com o couro cabeludo começando a aparecer.' },
    { value: 'I-4', label: 'I-4', caption: 'Leve a moderada', image: 'savin-4.png', help: 'Risca bem alargada, rarefação nítida no topo.' },
    { value: 'II-1', label: 'II-1', caption: 'Moderada', image: 'savin-5.png', help: 'Rarefação moderada no topo, com área de couro cabeludo visível ao redor da risca.' },
    { value: 'II-2', label: 'II-2', caption: 'Moderada a intensa', image: 'savin-6.png', help: 'Rarefação extensa no topo, couro cabeludo bem visível.' },
    { value: 'III', label: 'III', caption: 'Intensa', image: 'savin-7.png', help: 'Topo com pouca cobertura, faixa frontal preservada.' },
    { value: 'advanced', label: 'Avançado', caption: 'Muito intensa', image: 'savin-8.png', help: 'Topo quase sem cobertura, com a frente ainda presente.' },
    { value: 'frontal', label: 'Frontal', caption: 'Padrão frontal', image: 'savin-9.png', help: 'Perda que começa pela linha frontal, com recuo ou rarefação na frente.' },
  ],
};

export default savin;
